import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import Loading from "vue-loading-overlay";
import axios from "axios";
import VueMoment from "vue-moment";
import Vuelidate from "vuelidate";
import VueSweetalert2 from "vue-sweetalert2";
import * as Sentry from "@sentry/browser";
import _ from "lodash";
import "bootstrap/scss/bootstrap.scss";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-loading-overlay/dist/vue-loading.min.css";
import "./style.scss";


localStorage.setItem("shopifyBrands", ["FF"]);
Vue.config.productionTip = false;
Vue.prototype._ = _;
Vue.use(BootstrapVue);
Vue.use(VueMoment);
Vue.use(Loading);
Vue.use(Vuelidate);
Vue.use(VueSweetalert2);
Vue.prototype.$http = axios;
Vue.prototype.SHOPIFYBRANDS = localStorage.getItem("shopifyBrands");
Vue.prototype.BRAND = localStorage.getItem("brand")
  ? localStorage.getItem("brand")
  : "IM";
Vue.prototype.APIURL = process.env.VUE_APP_API_URL;
Vue.prototype.BASE_URL = process.env.BASE_URL;

Sentry.init({
  dsn: process.env.VUE_APP_DNS,
  integrations: [new Sentry.Integrations.Vue({ Vue })]
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
